export const labTestDescriptionSkeleton = [
    {
        span: 6,
        height: "32px",
        classes: "marginTop-8 marginBottom-16",
    },

    {
        span: 6,
        height: "32px",
        classes: "marginTop-8",
    },

    {
        span: 15,
        height: "1px",
        classes: "marginTop-24",
    },

    {
        span: 10,
        height: "24px",
        classes: "marginTop-24 marginBottom-24",
    },

    {
        span: 15,
        height: "80px",
        classes: "marginTop-16",
    },
]
